import { render, staticRenderFns } from "./MetricWidget.vue?vue&type=template&id=6a2bf276"
import script from "./MetricWidget.vue?vue&type=script&lang=ts"
export * from "./MetricWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports